import { createContext } from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
export var listInputElementLinesContext = createContext(ouiStyle.Constants.linesDefault);
